import axiosInstance from "../interceptor/instance";

export const deleteNotifications = async (id) => {
  const deleteNoti = await axiosInstance.delete(
    `${process.env.REACT_APP_BASE_URL_LOGS}/notification/${id}`
  );
  return deleteNoti;
};
